import {
  WorkflowService,
  WorkflowTypes
} from '../NewWorkflow/newWorkflowReducer';

export interface DuplicateWorkflowResponse {
  id: string;
}

export interface DuplicateWorkflowRequest {
  name: string;
  workflowType: string;
  serviceId?: string;
  copyMapperSettings: boolean;
}

export enum DuplicateWorkflowActionKind {
  SET_FORMS,
  SET_ISLOADING,
  SET_NEW_WORKFLOW_NAME,
  SET_ERROR,
  SET_ERROR_MESSAGE,
  SET_SELECTED_FORM
}

export interface DuplicateWorkflowAction {
  type: DuplicateWorkflowActionKind;
  payload?:
    | WorkflowService[]
    | boolean
    | string
    | WorkflowTypes
    | null
    | SelectedForm;
}

export interface DuplicateWorkflowState {
  forms: WorkflowService[];
  isLoading: boolean;
  workflowType: WorkflowTypes;
  newWorkflowName: string;
  hasError: boolean;
  errorMessage: string;
  selectedForm: string | null;
  selectedId: string;
}

export interface SelectedForm {
  id: string;
  value: string;
}

export interface DuplicateWorkflowProps {
  workflowId: string;
  workflowName: string;
  workflowType: WorkflowTypes;
}
